import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {ContractWrapperModel} from '../../../models/contract.model';
import {MemberModel} from '../../../models/user.model';
import {ContractsService} from '../../../services/api/contracts.service';
import {HelpersService} from '../../../services/helpers.service';
import {MemberService} from '../../../services/member.service';
import {AlertService} from '../../../services/notify/alert.service';
import {ModalService} from '../../../services/modal/modal.service';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-button-create-contract',
    templateUrl: './button-create-contract.component.html',
    styleUrls: ['./button-create-contract.component.scss']
})
export class ButtonCreateContractComponent implements OnInit {

    @Input() public isNavigate = true;

    @Output() public emitReload: EventEmitter<any> = new EventEmitter<any>();

    @Input() public finance = false;

    @ViewChild('createContractView') public createContractView;

    public profile: MemberModel;

    public isPermissionConfirmed = false;

    public description = '';

    isLockButton = false;

    constructor(
        protected alertService: AlertService,
        protected memberService: MemberService,
        protected modelService: ModalService,
        public helper: HelpersService,
        public contractApi: ContractsService,
        public router: Router,
        private translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        this.memberService.getCurrentMember().then(data => {
            this.profile = data;
            this.isPermissionConfirmed = this.profile.project_setting.is_project_admin;
        });
    }

    openModal(): void {
        this.modelService.openTemplateModal(this.createContractView);
    }

    createContracts(contractName, modal: NgbModalRef): void {
        if (!contractName.value) {
            this.alertService.setAlert(this.translate.instant('ALERTS.CREATE_CONTRACT'), 'blue');
        } else {
            this.isLockButton = true;
            const data = {
                name: contractName.value,
                description: this.description ? this.description : null,
                members: []
            };
            this.contractApi.create(data).subscribe({
                next: async (res: { contract: ContractWrapperModel, message: string }) => {
                    modal.close();
                    this.alertService.setAlert(res.message, 'green');
                    if (this.isNavigate) {
                        await this.router.navigate(['account', 'contract', res.contract.contract.guid]);
                    } else {
                        this.emitReload.emit();
                    }
                    this.isLockButton = false;
                    this.description = '';
                }, error: error => {
                    this.alertService.setAlert(error.message, 'blue');
                    this.isLockButton = false;
                }
            });
        }
    }
}
